/**
 * src/lib/clarity.js — Microsoft Clarity: ghi lại phiên và bản đồ nhiệt.
 *
 * Chỉ tải sau khi người dùng đồng ý (gọi từ src/lib/track.js). Không có
 * VITE_CLARITY_ID thì mọi hàm ở đây không làm gì.
 *
 * Che dữ liệu: Clarity tự che ô nhập liệu. Ngoài ra App.jsx gắn
 * data-clarity-mask="True" cho trang công cụ, Bản chuẩn bị, trang góp câu
 * chuyện và khu quản trị, vì KẾT QUẢ tính ra (runway, định giá, tỷ lệ cổ phần)
 * cũng là dữ liệu nhạy cảm dù không nằm trong ô nhập. Trong cài đặt project
 * Clarity nên chọn Masking = Strict (xem ANALYTICS.md).
 */
const ENV = import.meta.env || {};
const MA = String(ENV.VITE_CLARITY_ID || '').trim();
export const CLARITY_BAT = /^[a-z0-9]{6,20}$/i.test(MA);

let daTai = false;

export function taiClarity() {
  if (!CLARITY_BAT || daTai || typeof window === 'undefined') return;
  daTai = true;
  const w = window;
  w.clarity = w.clarity || function clarity() { (w.clarity.q = w.clarity.q || []).push(arguments); };
  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://www.clarity.ms/tag/' + encodeURIComponent(MA);
  document.head.appendChild(s);
  // Báo cho Clarity biết người dùng đã đồng ý (bắt buộc với khách từ EU/UK).
  w.clarity('consentv2', { ad_Storage: 'denied', analytics_Storage: 'granted' });
}

/** Gắn nhãn sự kiện vào phiên ghi hình, để lọc "các phiên có tải mẫu" trên Clarity. */
export function suKienClarity(name) {
  if (!daTai || typeof window === 'undefined' || typeof window.clarity !== 'function') return;
  try { window.clarity('event', name); } catch { /* bỏ qua */ }
}

export function dungClarity() {
  if (!daTai || typeof window === 'undefined' || typeof window.clarity !== 'function') return;
  try {
    window.clarity('consentv2', { ad_Storage: 'denied', analytics_Storage: 'denied' });
    window.clarity('stop');
  } catch { /* bỏ qua */ }
}

export const MA_CLARITY = CLARITY_BAT ? MA : '';
